import { Card } from '@/entities/auth'
import { TTermsForm } from '@/features/sign-up'
import { Slot } from '@/shared/lib'

import { TermsForm } from './terms-form'

type Props = {
  onSubmit: (formValues: TTermsForm) => void
  defaultValues?: TTermsForm
  onFormFieldChange: (formValues: TTermsForm) => void
}

export const SignUpTerms = ({
  onSubmit,
  defaultValues,
  onFormFieldChange,
}: Props) => {
  return (
    <Card progress={25}>
      <Slot name="title">
        서비스 이용을 위해
        <br />
        이용약관에 동의해 주세요
      </Slot>
      <Slot name="children">
        <TermsForm
          onSubmit={onSubmit}
          defaultValues={defaultValues}
          onFormFieldChange={onFormFieldChange}
        />
      </Slot>
    </Card>
  )
}
